$.fn.stickyFooter = function() {
    var $footer = this;
    if ($footer.length) {
        var footerHeight = $footer.outerHeight();
        $('body').css({'position': 'relative', 'min-height': '100%'});
        $('main').css({'padding-bottom': footerHeight + 'px'});
        $footer.css({'position': 'absolute', 'bottom': '0', 'left': '0', 'z-index': '99', 'width': '100%', 'opacity': '1'});
        return this;
    }
};

var $footer = $('#footer');

$(window).on('load', function() {
    $footer.stickyFooter();
});

$(window).smartResize(function() {
    $footer.stickyFooter();
});
